// extracted by mini-css-extract-plugin
export default {"icon":"no-data_icon__Yotgi"};